import GettingStarted from 'components/Onboarding/GettingStarted/GettingStarted'
import AboutYou from 'components/Onboarding/AboutYou/AboutYou'
import PersonalInformation from 'components/Onboarding/PersonalInformation/PersonalInformation'
import IdentityVerification from 'components/Onboarding/IdentityVerification/IdentityVerification'
import EmploymentDetails from 'components/Onboarding/EmploymentDetails/EmploymentDetails'
import YourAccounts from 'components/Onboarding/YourAccounts/YourAccounts'
import AccountDetails from 'components/Onboarding/Accounts/AccountDetails/AccountDetails'
import ReviewAndSubmit from 'components/Onboarding/ReviewAndSubmit/ReviewAndSubmit'
import DocumentUploader from 'components/Shared/DocumentUploader/DocumentUploader'
import Confirmation from 'components/Onboarding/Confirmation/Confirmation'
import JointAccountHolder from 'components/Onboarding/Accounts/JointAccountHolder'
import AddEditContact from 'components/Onboarding/Accounts/AddEditContact'
import ContactIndexBase from 'components/Onboarding/Accounts/ContactIndexBase'
import EmployerInformation from 'components/Onboarding/EmployerInformation/EmployerInformation'
import AdditionalDetails from 'components/Onboarding/AdditionalDetails/AdditionalDetails'

export default {
  ONBOARDING: null,
  ONBOARDING_GETTING_STARTED: GettingStarted,
  ONBOARDING_ABOUT_YOU: AboutYou,
  ONBOARDING_PERSONAL_INFORMATION: PersonalInformation,
  ONBOARDING_IDENTITY_VERIFICATION: IdentityVerification,
  ONBOARDING_EMPLOYMENT_DETAILS: EmploymentDetails,
  ONBOARDING_YOUR_ACCOUNTS: YourAccounts,
  ONBOARDING_ACCOUNT_DETAILS: AccountDetails,
  ONBOARDING_REVIEW_AND_SUBMIT: ReviewAndSubmit,
  ONBOARDING_CONFIRMATION: Confirmation,
  ONBOARDING_JOINT_OWNER: JointAccountHolder,
  ONBOARDING_ADD_CONTACT: AddEditContact,
  ONBOARDING_EDIT_CONTACT: AddEditContact,
  ONBOARDING_CONTACTS_PAGE: ContactIndexBase,
  ONBOARDING_EMPLOYER_INFORMATION: EmployerInformation,
  ONBOARDING_ADDITIONAL_DETAILS: AdditionalDetails,
  SECURE_DOC_UPLOADER: null,
  SECURE_DOC_UPLOADER_PAGE: DocumentUploader,
}



// WEBPACK FOOTER //
// ./src/routing/router/onboarding.js